import React from 'react';
import { Box, ButtonBase, CircularProgress } from '@mui/material';
import { AU, BORDE_AZUL, CONTORNO_FOCO, FUENTE, RADIO_TARJETA, SOMBRA_BOTON } from '../../styles/tokensAU';

// Botón grande de ancho completo. El primario es blanco sobre AU Blue (3,80:1): solo cumple como
// texto grande, por eso la etiqueta va en bold de 19 px. `component="a"` lo vuelve un enlace.
const BotonAU = ({ children, cargando = false, disabled = false, variante = 'primario', sx, ...resto }) => {
  const base = {
    position: 'relative',
    width: '100%',
    minHeight: 48,
    px: 2,
    borderRadius: RADIO_TARJETA,
    fontFamily: FUENTE,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    textDecoration: 'none',
    transition: 'background-color 120ms',
    '&:focus-visible': { ...CONTORNO_FOCO },
  };
  const estilos = variante === 'primario'
    ? {
      ...base,
      fontSize: 19,
      fontWeight: 700,
      bgcolor: AU.azul,
      color: AU.blanco,
      boxShadow: SOMBRA_BOTON,
      '&:hover': { bgcolor: AU.azulHover },
      '&.Mui-disabled': { opacity: 0.6, color: AU.blanco, boxShadow: 'none' },
    }
    : {
      ...base,
      fontSize: 16,
      fontWeight: 600,
      bgcolor: AU.azulSuave,
      color: AU.azulHover,
      border: 0,
      '&:hover': { bgcolor: AU.azulSuave, boxShadow: `inset 0 0 0 1px ${BORDE_AZUL}` },
      '&.Mui-disabled': { opacity: 0.6 },
    };

  return (
    <ButtonBase
      disabled={disabled || cargando}
      aria-busy={cargando || undefined}
      disableRipple
      sx={[estilos, ...(Array.isArray(sx) ? sx : [sx])]}
      {...resto}
    >
      {/* Los children siguen en el árbol (opacity, no visibility) para que el botón conserve su nombre accesible. */}
      <Box component="span" sx={{ opacity: cargando ? 0 : 1 }}>{children}</Box>
      {cargando && (
        <CircularProgress size={22} aria-hidden="true" sx={{ position: 'absolute', color: 'inherit' }} />
      )}
    </ButtonBase>
  );
};

export default BotonAU;
